const ETimeScope = Object.freeze({
  Active: 0,
  Future: 1,
  Past: 2
});

export default ETimeScope;